/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 11/11/21
 */

import { ComponentType, ForwardRefRenderFunction } from 'react';

export const withDisplayName = <T>(Component: ComponentType<T>, name: string): ComponentType<T> => {
    Component.displayName = name;
    return Component;
};

export const withDisplayNameRef = <T, P>(
    Component: ForwardRefRenderFunction<T, P>,
    name: string,
): ForwardRefRenderFunction<T, P> => {
    Component.displayName = name;
    return Component;
};
